// @flow

import {loadStripe} from '@stripe/stripe-js';
import {THEMES, LOCATIONS, SIZES} from './constants';

export type State = {|
  theme: string,
  location: string,
  size: string,
  clientSecret: string,
  stripePromise: any,
|};

export type Action =
  | {|
      kind: 'THEME_CHANGED',
      theme: string,
    |}
  | {|
      kind: 'LOCATION_CHANGED',
      location: string,
    |}
  | {|
      kind: 'SIZE_CHANGED',
      size: string,
    |}
  | {|
      kind: 'SECRET_CHANGED',
      clientSecret: string,
    |}
  | {|
      kind: 'PAYMENT_METHOD_CHANGED',
      method: string,
    |};

export type Dispatch = (action: Action) => void;

export const reducer = (state: State, action: Action): State => {
  switch (action.kind) {
    case 'THEME_CHANGED': {
      const {theme} = action;
      return {
        ...state,
        theme,
      };
    }

    case 'SIZE_CHANGED': {
      const {size} = action;
      return {
        ...state,
        size,
      };
    }

    case 'LOCATION_CHANGED': {
      const {location} = action;
      return {
        ...state,
        location,
        clientSecret: '',
        stripePromise: loadStripe(LOCATIONS[location].publicKey),
      };
    }

    case 'SECRET_CHANGED': {
      const {clientSecret} = action;
      return {
        ...state,
        clientSecret,
      };
    }

    default: {
      return state;
    }
  }
};

export const getInitialState = (): State => ({
  theme: THEMES.default.key,
  location: LOCATIONS.us.key,
  size: SIZES.desktop.key,
  clientSecret: '',
  // Since Payment Element is still in beta, will use a hardcoded key for now.
  // This key need to match the key used for API call.
  // Can probably update to useAccount()'s publishbale key later, but this may impact
  // the supportability for each payment methods.
  stripePromise: loadStripe(LOCATIONS[LOCATIONS.us.key].publicKey),
});
